import { render, staticRenderFns } from "./CreatePostPreview.vue?vue&type=template&id=2ba670e8&"
import script from "./CreatePostPreview.vue?vue&type=script&lang=js&"
export * from "./CreatePostPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports